<script type="text/javascript">
    function preventBack() { window.history.forward(); }
    setTimeout("preventBack()", 0);
    window.onunload = function () { null };
</script>
<ng-container *ngIf="!userSessionService.isIntegration">
    <p *ngIf="userSessionService.authMessage">{{userSessionService.authMessage}}</p>
</ng-container>
<section class="text-center error-section" *ngIf="errorMessage">
    <div>
        <img src="../../../../assets/images/app-logo.png" class="mt-5 mb-3" height="60px"/>
        <p style="font-family: 'Poppins'; font-size: 16px;">The Most Advanced Solution For Property Maintenance.</p>
    </div>
    <div class="login-error">
        <h2>Your Account is not enabled</h2>
        <mat-error class="error-desc" [innerHTML]="errorMessage"></mat-error>
    </div>
    <div>
        <button mat-button class="common-button danger border-r5 w-270" (click)="signOut()">Back to Sign in</button>
    </div>
</section>
<app-switch-organization-popup *ngIf="configurationCheckPassed"></app-switch-organization-popup>